module.exports = __webpack_public_path__ + "img/CLS-P-310.599bed24.svg";